// const BASE_URL = "https://kadata-dev.kampmann.de/api/karest/kapi/v1.0/"


//Wird in der Azure PIPELINE je nach Umgebung gesetzt
// const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ? "https://" + process.env.NEXT_PUBLIC_BASE_URL : "https://kadata-dev.kampmann.de"
const BASE_URL = process.env.env === "local" ? "https://kadata-dev.kampmann.de" : "";

const CACHE_REVALIDATION = 1000 * 60 * 10;
const DISPLAY_API_ERRORS = process.env.env === "dev" || process.env.env === "local";

const KAREST_PATH = process.env.env === "local" ? "/api/karest/kapi/v1.0/" : "http://karest-service:80/kapi/v1.0/";
const CALCGATEWAY_PATH = process.env.env === "local" ? "/api/calcgateway/kapi/v1.0/" : "http://calcgateway-service:80/kapi/v1.0/";
const PROJECTSTORE_PATH = process.env.env === "local" ? "/api/karest/projectStore/v1.0/" : "http://karest-service:80/projectStore/v1.0/";
const PROJECTSTORE_CALCGATEWAY = process.env.env === "local" ? "/api/calcgateway/projectStore/v1.0/" : "http://calcgateway-service:80/projectStore/v1.0/";

const DATADOG_ACTIVE = false;
const WEBVITALS_ACTIVE = false;

const IS_PROD = !(process.env.NEXT_PUBLIC_ENVIRONMENT === "local" || process.env.NEXT_PUBLIC_ENVIRONMENT === "dev" || process.env.NEXT_PUBLIC_ENVIRONMENT === "stag");

const API_VALUES = {
    BASE_URL: BASE_URL,
    KAREST_PATH: KAREST_PATH,
    CALCGATEWAY_PATH: CALCGATEWAY_PATH,
    PROJECTSTORE_PATH: PROJECTSTORE_PATH,
    PROJECTSTORE_CALCGATEWAY: PROJECTSTORE_CALCGATEWAY
}

module.exports = {
    CACHE_REVALIDATION,
    DISPLAY_API_ERRORS,
    DATADOG_ACTIVE,
    WEBVITALS_ACTIVE,
    API_VALUES,
    IS_PROD
}